import React, { useState, useEffect } from 'react';
import logo from "../Images/logo.png";
import './Header.css';

function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const adminStatus = localStorage.getItem("isAdmin") === "true";
        setIsAdmin(adminStatus);
    }, []);

    const handleLinkClick = (e, target) => {
        e.preventDefault();
        setMenuOpen(false);
        const section = document.querySelector(target);
        if (section) section.scrollIntoView({ behavior: 'smooth' });
    };

    const handleLogout = () => {
        localStorage.removeItem("isAdmin");
        localStorage.removeItem("adminToken");
        window.location.href = "/"; // redirect to homepage
    };

    return (
        <header className="header">
            <div className="logo-container">
                <img src={logo} alt="Logo" className="logo" />
                <h1 className="brand-name">Rapid Physio</h1>
            </div>

            <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
                <a href="#hero" onClick={(e) => handleLinkClick(e, '#hero')}>Home</a>
                <a href="#services" onClick={(e) => handleLinkClick(e, '#services')}>Services</a>
                <a href="#about" onClick={(e) => handleLinkClick(e, '#about')}>About</a>
                <a href="#team" onClick={(e) => handleLinkClick(e, '#team')}>Team</a>
                <a href="#footer" onClick={(e) => handleLinkClick(e, '#footer')}>Contact</a>

                {/* ✅ Show Admin Dashboard + Logout only if admin logged in */}
                {isAdmin && (
                    <>
                        <a
                            href="/admin"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="admin-link"
                        >
                            Admin Dashboard
                        </a>
                        <button className="logout-btn" onClick={handleLogout}>
                            Logout
                        </button>
                    </>
                )}
            </nav>

            <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
                ☰
            </button>

            <div className="appointment-btn">
                <a href="tel:+91 7653009332" className="call-btn">Call for Appointment</a>
            </div>
        </header>
    );
}

export default Header;
